/**
 * Klaviyo "Added to Cart" tracking.
 *
 * Subscribes to Broadcast's `cartUpdate` PubSub event, which is published by the
 * shared product-form on BOTH the PDP and the quick-add modal (and only on add —
 * never on qty/remove). Fetches the live cart and pushes the event to Klaviyo's
 * _learnq.
 */
(function () {
  'use strict';

  function trackAddedToCart() {
    fetch(`${window.location.origin}/cart.js`)
      .then((res) => res.json())
      .then((data) => {
        const payload = {
          total_price: data.total_price / 100,
          $value: data.total_price / 100,
          total_discount: data.total_discount,
          original_total_price: data.original_total_price / 100,
          items: data.items
        };
        
        const _learnq = window._learnq || [];
        _learnq.push(['track', 'Added to Cart', payload]);
      })
      .catch(() => {});
  }

  function init() {
    if (typeof window.subscribe !== 'function' || !window.theme?.PUB_SUB_EVENTS?.cartUpdate) return;
    window.subscribe(window.theme.PUB_SUB_EVENTS.cartUpdate, trackAddedToCart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
